import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/dashboard/_trucks/caminhoes/marcas/editar/")({
  beforeLoad: () => {
    throw redirect({ to: ".." });
  }
});
